import { memo, type ReactNode } from 'react';
import { Rank } from '@wg/wows-react-uikit';

import { DEFAULT_ERROR } from '~/helpers/formatting';
import { hasAnyRank, hasSeasonRank } from '~/helpers/rank';
import { MemberInfoMissingTooltip } from '~/tooltips';

import type { RankLevels } from '@wg/wows-react-uikit/components/Rank/Rank';
import type { Nullable } from '~/types/generics';

interface RankCellProps {
  id?: number;
  rank?: number;
  seasonId: Nullable<number>;
  seasonRank: Nullable<number>;
  disableTooltip?: boolean;
}

const RankCell = ({ id, rank, seasonId, seasonRank, disableTooltip }: RankCellProps) => {
  let tooltipId: string | undefined;
  let dataTip: string | number | boolean | undefined;
  let content: ReactNode;

  if (hasAnyRank(rank, seasonRank, seasonId)) {
    content = hasSeasonRank(seasonRank, seasonId) ? <Rank level={seasonRank as RankLevels} /> : rank ?? DEFAULT_ERROR;

    if (!disableTooltip) {
      tooltipId = 'rank-tooltip';
      dataTip = id ?? true;
    }
  } else {
    content = DEFAULT_ERROR;

    if (!disableTooltip) {
      tooltipId = MemberInfoMissingTooltip.id;
      dataTip = true;
    }
  }

  return (
    <div data-tip={dataTip} data-for={tooltipId}>
      {content}
    </div>
  );
};

export default memo(RankCell);
